export { default } from './useExternalCoursesOpen';
